module.exports = __webpack_public_path__ + "static/media/HarryPotterCharacters_cover.2eab323f.png";